import bhPostaLogo from '../assets/bhPostaLogo.png';
import posteSrpskeLogo from '../assets/posteSrpskeLogo.png';
import milspedLogo from '../assets/milspedLogo.png';
import xExpressLogo from '../assets/xExpressLogo.png';
import euroexpressLogo from '../assets/euroexpressLogo.png';
import transferaLogo from '../assets/transferaLogo.png';
import {
  BH_POSTA,
  MILSPED,
  POSTE_SRPSKE,
  X_EXPRESS,
  EURO_EXPRESS,
  TRANSFERA,
} from './serviceNames';

export const SERVICE_DETAILS = {
  [BH_POSTA]: {
    logo: bhPostaLogo,
    url: 'https://www.posta.ba/pracenje-posiljaka/',
  },
  [POSTE_SRPSKE]: {
    logo: posteSrpskeLogo,
    url: 'https://www.postesrpske.com/pracenje-posiljaka/',
  },
  [MILSPED]: {
    logo: milspedLogo,
    url: 'https://m-one-bosnia.netlify.app/',
  },
  [X_EXPRESS]: {
    logo: xExpressLogo,
    url: 'https://www.x-express.ba/korisnicki-panel/pracenje-posiljke',
  },
  [EURO_EXPRESS]: {
    logo: euroexpressLogo,
    url: 'https://www.euroexpress.ba/pra%C4%87enje-po%C5%A1iljke',
  },
  [TRANSFERA]: {
    logo: transferaLogo,
    url: 'https://tracking.transfera.com/?culture=bs-Latn-BA',
  },
};
